import configureStore, { history } from './configureStore'

export const store = configureStore()
export { history }
